import React from 'react'
import * as Styled from './DeliveryBox.styles'
import SdfLink from './SdfLink'

const determineDeliveryFee = (
  fulfilmentAgent,
  deliveryPrice,
  fastTrack,
  freeDelivery,
  variableDeliveryPrice,
  sdf,
  isV2
) => {
  if (sdf) {
    return isV2 ? '' : 'Delivery options at checkout'
  }

  if (freeDelivery && variableDeliveryPrice) {
    return `Free delivery available`
  }

  switch (fulfilmentAgent) {
    case 'ADDO':
      return deliveryPrice === 0 ? `Free delivery available` : `Delivery from: £${deliveryPrice}`
    case 'ADTU':
      return `Standard delivery from: £${deliveryPrice}`
    case 'ADSI':
      if (!fastTrack && !freeDelivery && deliveryPrice !== 0) {
        return `Free delivery on orders over £100`
      }
      if (!fastTrack && freeDelivery) {
        return `Free delivery`
      }
      break
    default:
      return ''
  }

  return ''
}

export const DeliveryFee = ({ attributes, showDeliveryForm, deliveryIcon, isV2 }) => {
  const { fulfilmentAgent, deliveryPrice, fastTrack, freeDelivery, variableDeliveryPrice, sdf } = attributes
  const deliveryFee = determineDeliveryFee(
    fulfilmentAgent,
    deliveryPrice,
    fastTrack,
    freeDelivery,
    variableDeliveryPrice,
    sdf,
    isV2
  )

  const showDeliveryFee = !showDeliveryForm && deliveryIcon !== 'out_of_stock'

  /* PDP Hack: Change "cross" to "out_of_stock" as Basket yet to migrate to Bolt2 */
  return (
    showDeliveryFee && (
      <>
        {deliveryFee && (
          <Styled.FulfilmentDeliveryFee isV2={isV2} data-test='fulfilment-delivery-pricing'>
            {deliveryFee}
          </Styled.FulfilmentDeliveryFee>
        )}
        {sdf && <SdfLink isV2={isV2} />}
      </>
    )
  )
}
